import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

import { config } from './config'
import { autorun, isObservableProp, toJS, runInAction, observable, computed } from 'mobx'
import { bind } from 'bind-decorator'

firebase.initializeApp(config)

const settings = { timestampsInSnapshots: true }
firebase.firestore().settings(settings)

export async function loginAnoUser () {
  if (firebase.auth().currentUser) {
    return firebase.auth().currentUser
  } else {
    return firebase.auth().signInAnonymously()
  }
}

export class FirebaseBackedDoc {
  private _doc: firebase.firestore.DocumentReference
  @observable private _synced = false
  @observable private _onServer = false

  constructor (private _path: string, private _autoFetch = true, private _autoSave = false, private _ignorePropsRegex = /(_.*|constructor)/) {
    // console.log('Firebase get: ' + this._path)

    this._doc = firebase.firestore().doc(this._path)

    if (this._autoFetch) {
      this._doc.onSnapshot(this._onData, this._onError)
    } else {
      if (this._autoSave) {
        autorun(this.saveAll, { name: `firestore save ${this._path}` })
      }
    }

  }

  getFirebaseId () {
    if (this._doc) {
      return this._doc.id
    } else {
      return null
    }
  }

  @bind
  saveAll () {
    const save: any = {}
    for (const key in this) {
      if (! this._ignorePropsRegex.test(key) && isObservableProp(this, key)) {
        const value: any = this[key]
        if (value === undefined) continue
        if (value instanceof Date) {
          save[key] = firebase.firestore.Timestamp.fromDate(value)
        } else if (!(typeof value === 'function')) {
          save[key] = toJS(value)
        }
      }
    }
    return this._doc.set(save, { merge: true })
  }

  @bind
  private _onData (snapshot: firebase.firestore.DocumentSnapshot) {
    if (snapshot.exists) {
      runInAction(() => {
        this._onServer = true
        for (const key in this) {
          let value = snapshot.get(key)
          if (value === undefined) continue
          if (! this._ignorePropsRegex.test(key) && isObservableProp(this, key)) {
            if (value && value.toDate) {
              value = value.toDate()
            }
            this[key] = value
          }
        }
      })
    }
    runInAction(() => {
      this._synced = true
    })
    if (this._autoSave) {
      autorun(this.saveAll, { name: `firestore save ${this._path}` })
    }
  }

  @bind
  private _onError (err: Error) {
    throw err
  }

  @computed
  get isSynced () {
    return this._synced
  }

  @computed
  get isOnServer () {
    return this._onServer
  }

}



// WEBPACK FOOTER //
// ./src/firebase/index.ts